/**
 * Voice assistant open/close state.
 *
 * Lifted out of the floating button so any surface (e.g. the dashboard
 * voice hero card) can open the assistant panel, not just the FAB.
 */
import { create } from "zustand";

interface AssistantState {
	open: boolean;
	openAssistant: () => void;
	closeAssistant: () => void;
}

export const useAssistantStore = create<AssistantState>((set) => ({
	open: false,
	openAssistant: () => set({ open: true }),
	closeAssistant: () => set({ open: false }),
}));
